<div class="box" [style.display]="showFirstBox ? 'flex' : 'none'">
    <div *ngIf="comesFromStripe" class="order-success">
        <mat-icon class="success-icon">check_circle</mat-icon>
        <span class="title">{{'THANKS_FOR_YOUR_ORDER' | translate}}</span>
        <span class="subtitle">{{'COMPLETE_IT' | translate}}</span>
    </div>
    <img class="logo-image" src="./assets/images/logos/self-scanning-logo.png" alt="WikyScan">
    <p>Download SelfScanning</p>
    <a href="https://apps.apple.com/es/app/selfscanning/id6749220702" target="_blank">
        <img style="max-width: 40%;"
            src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/3c/Download_on_the_App_Store_Badge.svg/640px-Download_on_the_App_Store_Badge.svg.png"
            alt="Download on the App Store">
    </a>
    <button mat-raised-button color="primary" (click)="toggleShowFirst()">Next</button>
</div>

<div class="box" [style.display]="showFirstBox ? 'none' : 'flex'">
    <p>{{'SELFSCANNING_QR' | translate}}</p>
    <qrcode *ngIf="QRData" class="qrcode" [qrdata]="QRData" [errorCorrectionLevel]="'M'"></qrcode>
    <div class="order-success">
        <p style="margin-top: 0px;">{{'SELFSCANNING_CODE' | translate}}</p>
        <span *ngIf="qrCode" class="qr-code">{{qrCode}}</span>
    </div>
    <div *ngIf="wikyAppLink">
        or
        <a href="itms-apps://apps.apple.com/app/id123456789">Magic link</a>
    </div>

    <button mat-raised-button color="primary" (click)="toggleShowFirst()">Back</button>
</div>